export default __webpack_public_path__ + "static/media/Minicard_6s.dc73a3f2.svg";